import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { InventoryEntryStateEnums, InventoryEntryTypeEnums } from 'src/app/enum/inventory-entry-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { SubrentalEntryPrintModel } from 'src/app/models/print/subrental/subrental-entry-print.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { SubrentalEntryService } from 'src/app/services/subrental/subrental-entry.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-subrental-entry',
  templateUrl: './register-subrental-entry.component.html',
  styleUrls: ['./register-subrental-entry.component.scss'],
  standalone: false
})

export class RegisterSubrentalEntryComponent implements OnInit, OnDestroy {
  branchId: number = 0;
  companyId: number = 0;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledState: boolean = false;
  finishLoadingPrint: boolean = false;
  formSubrentalEntry: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  iconState: string = "pi pi-lock-open";
  inventorySubrentalId: number = 0;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Entradas de Subalquiler';
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = "danger";
  stateOpen: number = InventoryEntryStateEnums.open;
  stateText: string = 'Abierta';
  subrentalEntryContract: InventoryEntryModel = new InventoryEntryModel();
  subrentalEntryPrintModel: SubrentalEntryPrintModel = new SubrentalEntryPrintModel();
  subrentalEntryId: number = 0;
  subrentalEntryTypeId: number = InventoryEntryTypeEnums.subRental;
  titleState: string = "";
  url: string = "subrental-entry";
  userAuthenticated: UserModel = new UserModel();
  visibleState: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private subrentalEntryService: SubrentalEntryService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
  }

  async ngOnInit(): Promise<void> {
    this.headerService.setTitle(this.nameWindow);
    await this.validateForm(new InventoryEntryModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.subrentalEntryId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  async changeConsecutive() {
    const branchId = this.formSubrentalEntry.get("branchId")?.value;
    let consecutive = this.formSubrentalEntry.get("consecutive")?.value;

    if (this.subrentalEntryContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      await this.resetSubrentalEntry(branchId);
      return;
    }

    try {
      this.subrentalEntryContract = await firstValueFrom(this.subrentalEntryService.getSubrentalEntryByKeysAsync(branchId, consecutive));
      this.subrentalEntryId = this.subrentalEntryContract.inventoryEntryId;
      await this.validateForm(this.subrentalEntryContract);
    } catch (error) {
      console.error('Error al buscar la entrada de subalquiler por campos de recuperación.', error);
      await this.validateForm(this.subrentalEntryContract);
    }
  }


  changeSelection() {
    this.subrentalEntryId = 0;
    const modelSubrentalEntry = new InventoryEntryModel();
    modelSubrentalEntry.branchId = this.branchId;
    modelSubrentalEntry.inventoryEntryTypeId = this.subrentalEntryTypeId;
    this.subrentalEntryContract = modelSubrentalEntry;
    this.validateForm(modelSubrentalEntry);
  }

  async changeState() {
    if (!this.validations()) return;
    try {
      this.subrentalEntryContract = await firstValueFrom(this.subrentalEntryService.setSubrentalEntryState(this.subrentalEntryContract.inventoryEntryId));
      await this.validateForm(this.subrentalEntryContract);
      this.toastHandlerService.showToast('success', 'El estado de la entrada de subalquiler se modificó exitosamente.');
    } catch (error) {
      console.error('Error al cambiar el estado de la entrada de subalquiler.', error);
    }
  }

  async createNewSubrentalEntry() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear entrada de subalquiler. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }

    this.subrentalEntryId = 0;
    this.subrentalEntryContract = new InventoryEntryModel();
    this.subrentalEntryContract.branchId = this.branchId;
    this.quantityDetails = 0;
    await this.validateForm(this.subrentalEntryContract);
    this.location.replaceState(`/subrental-entry/register`);
  }

  async deleteSubrentalEntry() {
    if (!this.validations()) return;

    if (this.subrentalEntryContract.inventoryEntryStateId != InventoryEntryStateEnums.open) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la entrada de subalquiler no está abierta.', 'Atención');
      return;
    }

    if (this.quantityDetails != 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar, la entrada de subalquiler tiene artículos relacionados.', 'Atención');
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: `¿Realmente desea eliminar la entrada de subalquiler ${this.subrentalEntryContract.consecutive}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.subrentalEntryService.deleteSubrentalEntry(this.subrentalEntryContract.inventoryEntryId));
        this.toastHandlerService.showToast('success', 'La entrada de subalquiler fue eliminada exitosamente.', '');
        this.createNewSubrentalEntry();
      } catch (error) {
        console.error('Error al eliminar la entrada de subalquiler.', error);
      }
    }
  }

  disabledButtons() {
    this.disabledDetail = true;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists() {
    try {
      const [branches] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync())
      ]);
      this.listBranches = branches;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        validBranch = branchId;
      }
    }
    this.branchId = validBranch ?? 0;
    this.formSubrentalEntry.controls["branchId"].patchValue(validBranch);

    if (reload) {
      this.changeSelection();
    }
  }

  getButtonClick(buttonClick: any) {
    let consecutive = this.formSubrentalEntry.get("consecutive")?.value;
    const branchId = this.formSubrentalEntry.get("branchId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleSubrentalEntryNavigation(buttonClick, branchId, consecutive);
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
    this.branchId = response.branchId;
    this.getBranch(response.branchId, false);
    this.companyId = response.companyId;
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.subrentalEntry));
  }

  async getInventorySubrental() {
    const response = await firstValueFrom(this.inventoryService.getInventorySubrental());
    if (response) {
      this.inventorySubrentalId = response.inventoryId
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }

    await Promise.all([
      this.getInventorySubrental(),
      this.getFirstBranchByUserAuthenticatedAsync(),
    ]);

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();

      await this.getAllLists();

    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.SubrentalEntry));
  }

  async getSubrentalEntryById() {
    try {
      this.subrentalEntryContract = await firstValueFrom(this.subrentalEntryService.getSubrentalEntryById(this.subrentalEntryId));
      this.subrentalEntryId = this.subrentalEntryContract.inventoryEntryId;
      this.branchId = this.subrentalEntryContract.branchId;
      await this.validateForm(this.subrentalEntryContract);
    } catch (error) {
      console.error('Error al buscar la entrada de subalquiler.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/subrental-entry']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async handleInitialState() {
    if (this.subrentalEntryId !== null && this.subrentalEntryId !== 0) {
      await this.getSubrentalEntryById();
    } else {
      this.createNewSubrentalEntry();
    }
  }

  private async handleSubrentalEntryNavigation(buttonClick: any, branchId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<InventoryEntryModel>> = {
      first: () => firstValueFrom(this.subrentalEntryService.getFirstSubrentalEntryByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.subrentalEntryService.getPreviusSubrentalEntryByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.subrentalEntryService.getNextSubrentalEntryByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.subrentalEntryService.getLastSubrentalEntryByKeysAsync(branchId))
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) {
      await this.resetSubrentalEntry(branchId);
      return;
    }

    try {
      const subrentalEntry = await action();
      this.subrentalEntryContract = subrentalEntry;
      this.subrentalEntryId = subrentalEntry.inventoryEntryId;
      await this.validateForm(subrentalEntry);
      this.location.replaceState(`/subrental-entry/register/${this.subrentalEntryId}`);
    } catch (error) {
      console.error(`Error al buscar la entrada de subalquiler (${buttonClick.target.id}).`, error);
    }
  }

  async printPage() {
    if (!this.validations()) return;

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', `No es posible imprimir la entrada de subalquiler, no tiene ningún detalle.`);
      return;
    }

    if (this.subrentalEntryContract.inventoryEntryStateId === InventoryEntryStateEnums.open) {
      this.toastHandlerService.showToast('warning', `No es posible imprimir, la entrada de subalquiler se encuentra en estado abierto.`);
      return;
    }

    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getPrintSubrentalEntrys();
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async getPrintSubrentalEntrys() {
    this.subrentalEntryPrintModel = await firstValueFrom(this.subrentalEntryService.getSubrentalEntryByKeysByPrint(0, 0, this.subrentalEntryContract.inventoryEntryId));
  }

  async resetSubrentalEntry(branchId: number) {
    this.subrentalEntryId = 0;
    this.subrentalEntryContract = new InventoryEntryModel();
    this.subrentalEntryContract.branchId = branchId;
    await this.validateForm(this.subrentalEntryContract);
  }

  async send(): Promise<any> {
    if (this.disabledForm) {
      this.toastHandlerService.showToast('warning', `No es posible guardar, la entrada de subalquiler NO se encuentra en estado abierto.`);
      return;
    }

    if (this.formSubrentalEntry.valid) {
      const modelsubrentalEntry = this.formSubrentalEntry.getRawValue();

      //Hago null, los campos que permiten ser nulos:
      modelsubrentalEntry.remission = modelsubrentalEntry.remission || null;
      modelsubrentalEntry.observation = modelsubrentalEntry.observation || null;

      if (this.subrentalEntryId == 0) {
        modelsubrentalEntry.inventoryId = this.inventorySubrentalId;
        modelsubrentalEntry.inventoryEntryTypeId = this.subrentalEntryTypeId;
        try {
          const response = await firstValueFrom(this.subrentalEntryService.createSubrentalEntry(modelsubrentalEntry));
          this.toastHandlerService.showToast('success', `La entrada de subalquiler fue creada exitosamente.`);
          this.subrentalEntryContract = response;
          this.subrentalEntryId = this.subrentalEntryContract.inventoryEntryId;
          await this.validateForm(this.subrentalEntryContract);
          this.location.replaceState(`/subrental-entry/register/${this.subrentalEntryId}`);
        } catch (error) {
          console.error('Error al crear la entrada de subalquiler.', error);
        }
      } else {
        this.subrentalEntryContract.dateEntry = modelsubrentalEntry.dateEntry;
        this.subrentalEntryContract.remission = modelsubrentalEntry.remission;
        this.subrentalEntryContract.observation = modelsubrentalEntry.observation;
        try {
          const response = await firstValueFrom(this.subrentalEntryService.updateSubrentalEntry(this.subrentalEntryContract));
          this.toastHandlerService.showToast('success', `La entrada de subalquiler fue modificada exitosamente.`);
          this.subrentalEntryContract = response;
          await this.validateForm(this.subrentalEntryContract);
        } catch (error) {
          console.error('Error al actualizar la entrada de subalquiler.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      dateEntry: 'El campo fecha de entrada es obligatorio.',
      remission: 'El campo remisión permite máximo 15 caracteres.',
      observation: 'El campo observación permite máximo 250 caracteres.'
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formSubrentalEntry.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control]);
      }
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [InventoryEntryStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.subrentalEntryId !== 0,
      },
      [InventoryEntryStateEnums.close]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      },
    };

    const currentState = this.subrentalEntryContract.inventoryEntryStateId;
    const config = stateConfig[currentState];

    if (config) {
      this.severityState = config.severity;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = config.isDisabled;

      setTimeout(() => {
        config.isDisabled ? this.formSubrentalEntry.disable() : this.formSubrentalEntry.enable();
        const control = this.formSubrentalEntry.controls["consecutive"];
        config.enableConsecutive ? control.enable() : control.disable();
      }, 100);
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formSubrentalEntry.disable(), 100);
    setTimeout(() => this.formSubrentalEntry.controls["branchId"].enable(), 100);
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para modificar la entrada subalquiler. Comuníquese con el administrador del sistema', 'Atención');
      return false;
    }

    if (this.subrentalEntryContract.inventoryEntryId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado de la entrada de subalquiler.', 'Atención');
      return false;
    }
    return true;
  }

  validateForm(subrentalEntry: InventoryEntryModel) {
    this.formSubrentalEntry = this.formBuilder.group({
      branchId: [subrentalEntry.branchId, [Validators.required, Validators.min(1)]],
      inventoryEntryTypeId: [subrentalEntry.inventoryEntryTypeId, [Validators.required, Validators.min(1)]],
      consecutive: [subrentalEntry.consecutive, []],
      dateEntry: [subrentalEntry.dateEntry ?
        this.dateConverterService.convertUtcToLocalDate(subrentalEntry.dateEntry) : null, [Validators.required]],
      remission: [subrentalEntry.remission, [Validators.maxLength(15)]],
      observation: [subrentalEntry.observation, [Validators.maxLength(250)]]
    });

    this.updateFormState();
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();

          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
}
